import _slicedToArray from "/codebuild/output/src1305/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function isHexColor(hex) {
  var HEX_REGEXP = /^#?([0-9A-F]{3}){1,2}([0-9A-F]{2})?$/i;
  return HEX_REGEXP.test(hex);
}
function hexToRgba(color) {
  var hexString = color.replace("#", "");
  if (hexString.length === 3) {
    var shorthandHex = hexString.split("");
    hexString = [shorthandHex[0], shorthandHex[0], shorthandHex[1], shorthandHex[1], shorthandHex[2], shorthandHex[2]].join("");
  }
  if (hexString.length === 8) {
    var alpha = parseInt(hexString.slice(6, 8), 16) / 255;
    return {
      r: parseInt(hexString.slice(0, 2), 16),
      g: parseInt(hexString.slice(2, 4), 16),
      b: parseInt(hexString.slice(4, 6), 16),
      a: alpha
    };
  }
  var parsed = parseInt(hexString, 16);
  var r = parsed >> 16 & 255;
  var g = parsed >> 8 & 255;
  var b = parsed & 255;
  return {
    r: r,
    g: g,
    b: b,
    a: 1
  };
}
function rgbStringToRgba(color) {
  var _color$replace$split$ = color.replace(/[^0-9,./]/g, "").split(/[/,]/).map(Number),
    _color$replace$split$2 = _slicedToArray(_color$replace$split$, 4),
    r = _color$replace$split$2[0],
    g = _color$replace$split$2[1],
    b = _color$replace$split$2[2],
    a = _color$replace$split$2[3];
  return {
    r: r,
    g: g,
    b: b,
    a: a || 1
  };
}
function hslStringToRgba(hslaString) {
  var hslaRegex = /^hsla?\(\s*(\d+)\s*,\s*(\d+%)\s*,\s*(\d+%)\s*(,\s*(0?\.\d+|\d+(\.\d+)?))?\s*\)$/i;
  var matches = hslaString.match(hslaRegex);
  if (!matches) {
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 1
    };
  }
  var h = parseInt(matches[1], 10);
  var s = parseInt(matches[2], 10) / 100;
  var l = parseInt(matches[3], 10) / 100;
  var a = matches[5] ? parseFloat(matches[5]) : void 0;
  var chroma = (1 - Math.abs(2 * l - 1)) * s;
  var huePrime = h / 60;
  var x = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var m = l - chroma / 2;
  var r;
  var g;
  var b;
  if (huePrime >= 0 && huePrime < 1) {
    r = chroma;
    g = x;
    b = 0;
  } else if (huePrime >= 1 && huePrime < 2) {
    r = x;
    g = chroma;
    b = 0;
  } else if (huePrime >= 2 && huePrime < 3) {
    r = 0;
    g = chroma;
    b = x;
  } else if (huePrime >= 3 && huePrime < 4) {
    r = 0;
    g = x;
    b = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    r = x;
    g = 0;
    b = chroma;
  } else {
    r = chroma;
    g = 0;
    b = x;
  }
  return {
    r: Math.round((r + m) * 255),
    g: Math.round((g + m) * 255),
    b: Math.round((b + m) * 255),
    a: a || 1
  };
}
function toRgba(color) {
  if (isHexColor(color)) {
    return hexToRgba(color);
  }
  if (color.startsWith("rgb")) {
    return rgbStringToRgba(color);
  }
  if (color.startsWith("hsl")) {
    return hslStringToRgba(color);
  }
  return {
    r: 0,
    g: 0,
    b: 0,
    a: 1
  };
}
export { toRgba };